"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtuPerHourPerFeetPerFahrenheit = exports.WattPerMeterPerKelvin = void 0;
// import { Meter } from "./base-units";
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var power_1 = require("./power");
var delta_temperature_1 = require("./delta-temperature");
var length_1 = require("./length");
// Thermal conductivity
exports.WattPerMeterPerKelvin = UnitDivide.heatCapacityRateByLength("WattPerMeterPerKelvin", UnitDivide.powerByDeltaTemperature("", power_1.Watt, delta_temperature_1.DeltaCelsius), uom_1.BaseUnits.Meter);
exports.BtuPerHourPerFeetPerFahrenheit = UnitDivide.heatCapacityRateByLength("BtuPerHourPerFeetPerFahrenheit", UnitDivide.powerByDeltaTemperature("", power_1.BtuPerHour, delta_temperature_1.DeltaFahrenheit), length_1.Foot);
//# sourceMappingURL=thermal-conductivity.js.map